import { useDictionary } from "@/components/DictProvider/DictProvider";
import NotifyButton from "@/components/Product/NotifyButton/NotifyButton";
import useImageUrlModifier from "@/lib/useImageUrlModifier";
import React, { useRef, useState } from "react";

interface VideoPlayerProps {
  videoUrl: string;
  play: boolean;
  stock: boolean;
  productId: string;
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({ videoUrl, play, stock, productId }) => {
  const modifyImageUrl = useImageUrlModifier()
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState(play);
  const translate = useDictionary();
  const handlePlayVideo = () => {
    if (videoRef.current) {
      videoRef.current.play();
      setIsPlaying(true);
    }
  };

  return (
    <div className="relative w-full aspect-square flex justify-center items-center">
      <video
        ref={videoRef}
        className="w-full h-auto"
        src={modifyImageUrl(videoUrl, 0, 0, true) || ""}
        playsInline
        controls={isPlaying}
        autoPlay={isPlaying}
        onEnded={() => setIsPlaying(false)}
      />
      {!isPlaying && (
        <svg
          onClick={handlePlayVideo}
          width="68"
          height="68"
          viewBox="0 0 68 68"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] flex items-center justify-center cursor-pointer"
        >
          <path
            d="M26.917 44.1572V23.8479C26.9174 23.5938 26.9862 23.3445 27.1161 23.1261C27.246 22.9077 27.4322 22.7283 27.6553 22.6066C27.8784 22.4849 28.1301 22.4255 28.384 22.4345C28.6379 22.4435 28.8848 22.5207 29.0987 22.6579L44.8973 32.8097C45.0974 32.9379 45.262 33.1143 45.376 33.3228C45.49 33.5312 45.5497 33.765 45.5497 34.0026C45.5497 34.2402 45.49 34.4739 45.376 34.6824C45.262 34.8908 45.0974 35.0672 44.8973 35.1954L29.0987 45.3501C28.8848 45.4873 28.6379 45.5645 28.384 45.5735C28.1301 45.5825 27.8784 45.5231 27.6553 45.4014C27.4322 45.2797 27.246 45.1003 27.1161 44.8819C26.9862 44.6635 26.9174 44.4142 26.917 44.1601V44.1572Z"
            fill="#ededed"
          />
          <path
            d="M2.83301 33.9987C2.83301 16.7862 16.7872 2.83203 33.9997 2.83203C51.2122 2.83203 65.1663 16.7862 65.1663 33.9987C65.1663 51.2112 51.2122 65.1654 33.9997 65.1654C16.7872 65.1654 2.83301 51.2112 2.83301 33.9987ZM33.9997 7.08203C26.8609 7.08203 20.0146 9.91789 14.9667 14.9657C9.91886 20.0136 7.08301 26.86 7.08301 33.9987C7.08301 41.1374 9.91886 47.9838 14.9667 53.0317C20.0146 58.0795 26.8609 60.9154 33.9997 60.9154C41.1384 60.9154 47.9848 58.0795 53.0326 53.0317C58.0805 47.9838 60.9163 41.1374 60.9163 33.9987C60.9163 26.86 58.0805 20.0136 53.0326 14.9657C47.9848 9.91789 41.1384 7.08203 33.9997 7.08203Z"
            fill="#ededed"
          />
        </svg>
      )}

      {stock && (
        <div className="w-full h-full absolute inset-0 bg-[#E0E0E0]/50 rounded-md p-4">
          <div className=" relative inset-0 flex flex-col justify-between items-center  text-white font-semibold w-full h-full aspect-square text-center">
            <p className="rounded-b-[6px] text-sm bg-[#555555] py-1 px-4">
              {translate.poductDescriptionPage.outOfStock}
            </p>
            <div className="w-full flex justify-end">
              <NotifyButton productId={productId} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VideoPlayer;
